import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePrompt({ id }) {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.prompts.show(id))
      .then((response) => {
        setPrompt(response.data.data);
      });
  }, [id]);

  return prompt;
}
